module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"language":"Language","german":"German","english":"English","french":"French","italian":"Italian","spanish":"Spanish","portuguese":"Portuguese"},"de":{"language":"Sprache","german":"Deutsch","english":"Englisch","french":"Französisch","italian":"Italienisch","spanish":"Spanisch","portuguese":"Portugiesisch"}}')
  delete Component.options._Ctor
}
